
import { FontFamilySwitch } from "../../utils";
import makeStyles from "@mui/styles/makeStyles";

export const BarChart_Style = makeStyles((theme) => ({

  root: {
    paddingLeft:0,
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-20px",
    marginLeft:"30px",
    "& svg": {
      width: "100%",
      minWidth:  "165px !important",
      height:  "165px !important",
      position: "relative",
      cursor: "pointer",
      padding:'10px',
      "& .recharts-wrapper": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft:"105px"
      },
    },
  },
  main:{
    margin:"0 auto"
  },
  name: {
    color: theme.typography.color.primary,
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().bold,
  },
  value: {  
    color: theme.typography.color.primary,
    fontSize: "1rem",
    fontFamily: FontFamilySwitch().semiBold,
    marginRight: "8px",
  },
 }))